export const ACCOUNT_ROUTE_NAME = {
  ACCOUNT: "account",
  ORDER_LIST: "order-list",
  ORDER_DETAIL: "order-detail",
  ACCOUNT_SETTING: "account-setting",
  ADDRESS_PAYMENT: "address-payment",
  AFFILIATE: "affiliate",
  ADDRESS: "address",
  ADDRESS_EDIT: "address-edit",
  NEW_ADDRESS: "new-address",
  ACCOUNT_PROFILE: "account-profile",
  ACCOUNT_EDIT_PROFILE: "edit-profile",
  ACCOUNT_UPDATE_PASSWORD: "update-password",
  ABOUT_US: "about-us"
};

export const NAIL_SUPPLY_ROUTE_NAME = {
  CATEGORY: "categories",
  PRODUCT: "product",
  CART: "cart",
  SHIPPING_INFORMATION: "shipping-information",
  ADDRESS_SAVED: "address-saved",
  ORDER_PREVIEW: "order-preview",
  CHECKOUT: "checkout"
};

export const AUTH_ROUTE_NAME = {
  SIGNUP: "signup",
  SIGNIN: "signin",
  FORGOT_PASSWORD: "forgot-password",
  RESET_PASSWORD: "reset-password",
  VERIFY_EMAIL: "verify-email",
  ACTIVE_EMAIL: "active-email",
  SETUP_PASSWORD: "setup-password",
  AUTH: "auth"
};

export const MAIN_ROUTE_NAME = {
  HOME: "home",
  REFERRAL: "referral"
};

export const AFFILIATE_ROUTE_NAME = {
  AFFILIATE: "affiliate"
};

export const COURSE_ROUTE_NAME = {
  HOME: "courses",
  DETAIL: "course-detail",
  POST: "post-course"
};

export const POST_ROUTE_NAME = {
  POST: "post"
};

export const TECHNICIAN_ROUTE_NAME = {
  POST: "technician"
};

export const JOB_ROUTE_NAME = {
  HOME: "nail-job",
  DETAIL: "job-detail",
  POST: "post-job"
};

export const WORKER_ROUTE_NAME = {
  HOME: "nail-tech",
  DETAIL: "profile-detail",
  POST: "post-worker-profile"
};

export const SALON_ROUTE_NAME = {
  HOME: "salon-sale",
  DETAIL: "salon-sale-detail",
  POST: "post-salon"
};

export const POST_SAVED_ROUTE_NAME = {
  ALL_POST_SAVED: "all-post-saved"
};

export const ERROR_ROUTE_NAME = {
  ERROR: "error",
  ERROR_500: "error-500",
  NOT_FOUND: "not-found"
};

export const PROMOTION_ROUTE_NAME = {
  PROMOTION: "promotion"
};

export const BLANK_PAGE_ROUTE_NAME = {
  BLANK_PAGE: "blank-page"
};

export const NAILSUPPLY_ROUTE_NAME = {
  NAILSUPPLY: "nailsupply"
};
